export default {
	"address.buttonClick": "按钮点击",
	"address.edit": "编辑",
	"address.New": "新增",
	"address.NewRevenueAddress": "新增收货地址"
}